import React, { useEffect } from 'react'
import { Container, FormWrapper } from './RentalProductModal.styled'
import FullPageModal from '../../Modal/FullPageModal'

function RentalPoductModal({ open, onClose, isConfirmed, children }) {
  return (
    <FullPageModal open={open} onClose={onClose} preventCloseClick={isConfirmed}>
      <Container>
        <FormWrapper>{children}</FormWrapper>
      </Container>
    </FullPageModal>
  )
}

export default RentalPoductModal
